<template>
  <div class="step-container" :aria-current="state === StepState.active ? 'step' : undefined">
    <div :class="`step-number-container icon step-number-container-${state}`" aria-hidden="true">
      <img v-if="state === StepState.valid" class="icon" :src="loadIconArrow" :alt="$t('app.step.completed')" />
      <p v-else class="step-number">
        {{ number }}
      </p>
    </div>
    <div class="text-container">
      <p class="title" :class="`title-${state}`">
        <span class="visually-hidden" v-if="state === StepState.valid">{{ $t('app.step.completed') }} </span>
        <span class="visually-hidden" v-if="state === StepState.active">{{ $t('app.step.current') }} </span>
        {{ title }}
      </p>
      <div v-if="state === StepState.valid && subtitle" class="subtitle">
        <div>{{ subtitle }}</div>
        <div v-if="contractLabel" class="contract-label">{{ contractLabel }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export enum StepState {
  inactive = 'inactive',
  active = 'active',
  valid = 'valid',
}

export default defineComponent({
    setup() {
        return {
            StepState,
        };
    },
    props: {
        state: { type: String as PropType<StepState>, required: true },
        title: { type: String, required: true },
        subtitle: { type: String, required: false },
        contractLabel: { type: String, required: false },
        number: { type: Number, required: true },
    },
    computed: {
        loadIconArrow() {
            return require('@/assets/img/check.svg');
        },
    },
});
</script>

<style scoped>
.icon {
  width: 18px;
  margin: 0;
}
.step-number-container {
  height: 24px;
  width: 24px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.step-number-container-inactive {
  background-color: var(--medium-dark-grey);
}
.step-number-container-active {
  background-color: var(--color-principal);
}
.step-number-container-valid {
  background-color: var(--medium-green);
}
.step-number {
  color: var(--white);
  font-size: var(--font-size-very-small);
}
.title {
  display: inline;
  width: auto;
  color: var(--black);
  font-size: var(--font-size-low-medium);
  font-weight: var(--font-weight-normal);
}
.title-inactive {
  color: var(--medium-dark-grey);
}
.subtitle {
  color: var(--dark-grey);
  font-weight: var(--font-weight-300);
}
.contract-label {
  font-size: 10px;
}
.text-container {
  margin-left: 8px;
  display: flex;
  flex-direction: column;
}
.step-container {
  display: flex;
  padding-left: 8px;
  align-items: center;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
